// import { symbolsListManager } from "@/controllers/gridManager/PriceboardManager";
import PriceboardLayout from "@/views/layouts/PriceboardLayout";
// import { useEffect } from "react";

export default function PriceboardPage(props: { callBackFunc?: void }) {


    // useEffect(() => {
    //     getSymbolsList()
    // }, [])

    // const { getSymbolsListManager } = symbolsListManager()
    // const getSymbolsList = () => {
    //     // lấy dữ liệu danh sách mã CK.: Phục vụ tìm kiếm mã CK trên bảng giá
    //     getSymbolsListManager()
    // }
    return (
        <PriceboardLayout />
    );
}